import { CommonDto } from '@do/data-transfer-objects';
export const PresetKey = CommonDto.AssetPresetKey;
